<template>
  <div class="v-clean pt-2 pb-2 noBorderRadius">
    <div class="row m-0">
      <div class="col-md-6 pt-0 pb-0">
        <div class="row m-0">
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">RESIDENTE:</span>
            <strong>{{ item.resident_name }}</strong>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">MEDICAMENTO:</span>
            <strong>{{ item.medicine_name }}</strong>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">GRUPO:</span>
            <strong>{{ item.stock_group_name }}</strong>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">LOTE:</span>
            <strong>{{ item.lot }}</strong>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">
              {{ item.stock_item_unit_of_measurement_abbreviation }}:
            </span>
            <strong>
              {{ item.amount }}
              {{ item.stock_item_unit_of_measurement_abbreviation }}
            </strong>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">RESPONSÁVEL:</span>
            <strong>
              {{
                professionalClassCouncilValue({
                  id: item.user_professional_class_council_id,
                  name: item.user_name,
                  profile: item.user_profile_name,
                  office: item.user_office,
                  cpf: item.user_cpf,
                  value: item.user_professional_class_council_value,
                })
              }}
            </strong>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">DATA DO REGISTRO:</span>
            <strong>
              {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
            </strong>
          </div>
        </div>
      </div>
      <div class="col-md-4 pt-0 pb-0">
        <div class="row m-0">
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">DATA DA VENDA:</span>
            <strong>{{ moment(item.entry_date).format("DD/MM/YYYY") }}</strong>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <span class="text-muted mr-2">VALOR:</span>
            <strong>{{ formatReal(item.value) }}</strong>
          </div>
        </div>
      </div>
      <div
        class="
          col-md-2
          pt-0
          pb-0
          d-flex
          align-items-center
          justify-content-center
        "
      >
        <span class="text-muted mr-2">STATUS:</span>
        <div v-if="item.status == 0" class="d-flex align-items-center">
          <span>FATURADO</span>
          <v-icon class="ml-2" small color="success">
            mdi-check-circle-outline
          </v-icon>
        </div>
        <div v-else class="d-flex align-items-center">
          <span>FATURAMENTO PENDENTE</span>
          <v-icon class="ml-2" small color="orange">
            mdi-information-outline
          </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import {
  formatReal,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

export default {
  name: "ItemDetails",

  props: {
    item: Object,
  },

  created() {},

  methods: {
    moment,
    professionalClassCouncilValue,
    formatReal,
  },
};
</script>
